import React from 'react';
import { SvgIcon } from '@mui/material';

const EditIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 295 345"
      enableBackground="new 0 0 295 345"
      xmlSpace="preserve"
    >
      <path d="M227.625,172.798v127.346H43.459V66.454h76.667v-42H32.567c-17.153,0-31.108,14.061-31.108,31.342v255.007 c0,17.281,13.955,31.342,31.108,31.342h205.951c17.151,0,31.106-14.061,31.106-31.342V172.798H227.625z" />
      <g>
        <path d="M255.172,6.9c12.871,8.778,16.193,26.346,7.46,39.233l-10.563,15.556L205.455,29.9l10.561-15.556 C224.768,1.464,242.3-1.882,255.172,6.9z" />
        <g>
          <polygon points="141.3,224.85 241.508,77.243 194.893,45.454 94.696,193.064" />
          <polygon points="90.017,199.961 89.292,201.027 86.197,255.805 135.897,232.809 136.62,231.744" />
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default EditIcon;
